// Lògica comuna dels bàners del dossier a les pàgines d'estudi (DossierBanner i DossierTrustBanner):
// el dossier de l'assignatura (de /shop-list), les valoracions reals (/dossier-trust), afegir-lo a la cistella
// i, si l'assignatura no en té, l'avís "Avisa'm quan torni" (/dossier-requests, taula dossier_requests).
import Vue from 'vue'
import axios from 'axios'
import {addToCart} from '../../../shop/cart/cart'
import Shop from '../../../shop/Shop'

// Fotos de la comunitat (les de DossiersImages.vue, reduïdes a webp) i les valoracions d'Instagram amb foto
export const PHOTOS = Array.from({length: 9}, (_, i) => `/img/dossiers-comunitat/foto-0${i + 1}.webp`)
export const INSTAGRAM = [
  {name: 'Arnau C.', rating: 5, via: 'instagram', image: '/img/dossiers-comunitat/arnau.webp', text: "Us volia donar les gràcies, és la millor manera d'estudiar sele de forma eficient, guanyant molt temps"},
  {name: 'Xènia S.', rating: 5, via: 'instagram', image: '/img/dossiers-comunitat/xenia.webp', text: "Us volia donar les gràcies infinites pels dossiers! Són una passada! Tant a matemàtiques com a economia, em va súper bé tenir les solucions al costat per autocorregir-me."},
  {name: 'Narcís M.', rating: 4.5, via: 'instagram', image: '/img/dossiers-comunitat/narcis.webp', text: 'Moltes gràcies pels dossiers, són una passada! Gràcies per la feina que feu!!'}
]

const API_IMAGES = 'https://examenselectivitat.cat:3000/api/images/other/'

let shopPromise = null
export function loadShopList() {
  if (!shopPromise) {
    shopPromise = axios.get('/shop-list').then(r => r.data)
    shopPromise.catch(() => { shopPromise = null })
  }
  return shopPromise
}

let trustPromise = null
export function loadTrust() {
  if (!trustPromise) {
    trustPromise = axios.get('/dossier-trust').then(r => r.data)
    trustPromise.catch(() => { trustPromise = null })
  }
  return trustPromise
}

// Estat de les peticions per assignatura, compartit perquè els dos bàners de la pàgina canviïn alhora
export const requests = Vue.observable({})

/**
 * Dossier d'una assignatura: { book } si es ven, { soldOut: { name } } si no, o {} si no se sap.
 * Un sol cop per assignatura i pàgina.
 */
const dossierPromises = {}
export function loadSubjectDossier(subjectName, token) {
  if (!dossierPromises[subjectName]) {
    dossierPromises[subjectName] = loadShopList().then(async list => {
      for (const branch of list || []) {
        const book = (branch.subjects || []).find(b => b.subject_name === subjectName && !b.apunts)
        if (book) return {book}
      }
      const {data} = await axios.get(`/dossier-requests/${encodeURIComponent(subjectName)}`, {headers: {Authorization: token || 'NO_VALUE'}})
      Vue.set(requests, subjectName, {count: data.count, requested: data.requested || remembered(subjectName)})
      return {soldOut: {name: subjectName}}
    }).catch(() => ({}))
  }
  return dossierPromises[subjectName]
}

/**
 * Dossier d'apunts definitius i pack (quadern d'exàmens + apunts) d'una assignatura, si es venen: { notes, pack, exam }.
 * Són llibres amb apunts = 1 i books.content.kind 'notes' / 'pack' (els d'apunts del 2023 no hi entren).
 */
export function loadSubjectNotes(subjectName) {
  return loadShopList().then(list => {
    const all = (list || []).flatMap(b => [...(b.subjects || []), ...(b.apunts || [])])
    const notes = all.find(b => b.subject_name === subjectName && b.kind === 'notes') || null
    const pack = notes ? all.find(b => b.book_id === notes.packBookId) || null : null
    const exam = all.find(b => b.subject_name === subjectName && !b.apunts) || null
    return {notes, pack, exam}
  }).catch(() => ({}))
}

export async function requestDossier(subjectName, {email, token} = {}) {
  const {data} = await axios.post(`/dossier-requests/${encodeURIComponent(subjectName)}`,
    {email: email || null, pageUrl: window.location.href}, {headers: {Authorization: token || 'NO_VALUE'}})
  Vue.set(requests, subjectName, {count: data.count, requested: true})
  try {
    const all = JSON.parse(localStorage.getItem(REQUESTS_KEY) || '[]')
    if (!all.includes(subjectName)) localStorage.setItem(REQUESTS_KEY, JSON.stringify([...all, subjectName]))
  } catch (e) { /* sense emmagatzematge */ }
  return data
}

// Peticions fetes sense sessió en aquest navegador (amb sessió ho diu el servidor)
const REQUESTS_KEY = 'dossier-requests'
function remembered(name) {
  try { return JSON.parse(localStorage.getItem(REQUESTS_KEY) || '[]').includes(name) } catch (e) { return false }
}

export function coverUrl(book) {
  if (book.kind === 'notes' || book.kind === 'pack') return book.image
  return `${API_IMAGES}${book.subject_name}_examens_2025_sm.webp`
}

export function coverHoverUrl(book) {
  if (book.kind === 'notes' || book.kind === 'pack') return book.imageHover
  return `${API_IMAGES}${book.subject_name}_hover.png`
}

export function euros(value) {
  return Number(value).toFixed(2).replace('.', ',') + ' €'
}

/** Dia d'entrega en català ("dimecres, 7 d'octubre"), com a la botiga */
/**
 * Forquilla d'arribada de l'enviament estàndard (1-3 dies laborables des que surt la comanda), per dir
 * "entre el {from} i el {to}": {from: 'dimecres 14', to: 'divendres 16 d’octubre'} (el mes al from només si canvia).
 */
export function arrivesBetween() {
  const first = Shop.Instance.arrivesAtDate(1)
  const last = Shop.Instance.arrivesAtDate(3)
  const weekday = d => d.toLocaleDateString('ca-ES', {weekday: 'long'})
  const dayMonth = d => d.toLocaleDateString('ca-ES', {day: 'numeric', month: 'long'})
  return {
    from: weekday(first) + ' ' + (first.getMonth() === last.getMonth() ? first.getDate() : dayMonth(first)),
    to: weekday(last) + ' ' + dayMonth(last)
  }
}

export function deApostrof(assig) {
  const lletra = String(assig || '').charAt(0).toLowerCase()
  return 'aeiouhàèéíòóú'.includes(lletra) ? "d'" + assig : 'de ' + assig
}

/** Afegeix el dossier a la cistella (cookie `cart`, com la botiga) i hi porta */
export function buyBook(vm, book, placement) {
  const book_id = book.book_id
  vm.$funnel.adClick(placement, {book_id, subject_id: book.subject_id, meta: {target: 'add_to_cart'}})
  addToCart(vm, book_id)
  vm.$funnel.track('add_to_cart', {placement, book_id, subject_id: book.subject_id})
  vm.$router.push({path: '/checkout'})
}
